import { AfterViewInit, Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MdrtStatusV2 } from '../../dashboard-interfaces/mdrt-status-v2.interface';
import { MdrtStatusByAdvisorsV2 } from '../../dashboard-interfaces/mdrt-status-by-advisors-v2.interface';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { DashboardMdrtStatusServiceV2 } from '../../dashboard-services/dashboard-mdrt-status/dashboard-mdrt-status-v2.service';
import { HttpStatusCode } from 'axios';
import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TabStateV2 } from '../../dashboard-interfaces/tab-state-v2.interface';

@Component({
  selector: 'dashboard-mdrt-status-v2',
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatDividerModule
  ],
  templateUrl: './mdrt-status-v2.component.html',
  styleUrl: './mdrt-status-v2.component.scss'
})
export class MdrtStatusComponentV2 implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackbarServices = inject(SnackbarService);
  private dashboardMdrtStatusService = inject(DashboardMdrtStatusServiceV2);

  private currentUserRole: string = "";
  protected currentUserGroup: string = "";
  protected mdrtStatusIncomeCount: { mdrt: number, cot: number, tot: number } = {
    mdrt: 0,
    cot: 0,
    tot: 0
  };

  protected mdrtStatusCommissionCount: { mdrt: number, cot: number, tot: number } = {
    mdrt: 0,
    cot: 0,
    tot: 0
  };

  protected mdrtStatusPremiumCount: { mdrt: number, cot: number, tot: number } = {
    mdrt: 0,
    cot: 0,
    tot: 0
  };

  protected setSprinner = signal(false);
  protected isMdrtStatusDashboardHidden = signal(false);
  protected isMdrtStatusFilterAndPaginatorHidden = signal(false);
  protected isAffinityUser = signal(false);

  protected mdrtStatusIncomeData: MdrtStatusByAdvisorsV2[] = [];
  protected mdrtStatusIncomeTableDisplayFirstColumn: string[] = [];
  protected mdrtStatusIncomeTableDisplaySecondColumn: string[] = ["cotQualification", "cotTarget", "cotAchievedGr", "cotShortfall", "cotMetOrNotmet"];
  protected mdrtStatusIncomeTableDisplayThirdColumn: string[] = ["totQualification", "totTarget", "totAchievedGr", "totShortfall", "totMetOrNotmet"];
  protected mdrtStatusIncomeTableDataSource = new MatTableDataSource<MdrtStatusByAdvisorsV2>();

  protected mdrtStatusCommissionData: MdrtStatusByAdvisorsV2[] = [];
  protected mdrtStatusCommissionTableDisplayFirstColumn: string[] = [];
  protected mdrtStatusCommissionTableDisplaySecondColumn: string[] = ["cotQualification", "cotTarget", "cotAchievedGr", "cotShortfall", "cotMetOrNotmet"];
  protected mdrtStatusCommissionTableDisplayThirdColumn: string[] = ["totQualification", "totTarget", "totAchievedGr", "totShortfall", "totMetOrNotmet"];
  protected mdrtStatusCommissionTableDataSource = new MatTableDataSource<MdrtStatusByAdvisorsV2>();

  protected mdrtStatusPremiumData: MdrtStatusByAdvisorsV2[] = [];
  protected mdrtStatusPremiumTableDisplayFirstColumn: string[] = [];
  protected mdrtStatusPremiumTableDisplaySecondColumn: string[] = ["cotQualification", "cotTarget", "cotAchievedGr", "cotShortfall", "cotMetOrNotmet"];
  protected mdrtStatusPremiumTableDisplayThirdColumn: string[] = ["totQualification", "totTarget", "totAchievedGr", "totShortfall", "totMetOrNotmet"];
  protected mdrtStatusPremiumTableDataSource = new MatTableDataSource<MdrtStatusByAdvisorsV2>();

  mdrtStatusIncomeTableFilterFc = new FormControl("");
  mdrtStatusCommissionTableFilterFc = new FormControl("");
  mdrtStatusPremiumTableFilterFc = new FormControl("");

  @ViewChild('mdrtStatusIncomeTablePaginator')
  mdrtStatusIncomeTablePaginator!: MatPaginator;
  @ViewChild('mdrtStatusIncomeTableSort')
  mdrtStatusIncomeTableSort = new MatSort();
  @ViewChild('mdrtStatusCommissionTablePaginator')
  mdrtStatusCommissionTablePaginator!: MatPaginator;
  @ViewChild('mdrtStatusCommissionTableSort')
  mdrtStatusCommissionTableSort = new MatSort();
  @ViewChild('mdrtStatusPremiumTablePaginator')
  mdrtStatusPremiumTablePaginator!: MatPaginator;
  @ViewChild('mdrtStatusPremiumTableSort')
  mdrtStatusPremiumTableSort = new MatSort();
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('commissionSearchInput')
  commissionSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('premiumSearchInput')
  premiumSearchInput!: ElementRef<HTMLInputElement>;

  @Input('tabState')
  set tabState(state: TabStateV2) {
    this.isCurrentTabActive = state.isActive;
    this.targetYear = state.targetYear;

    this.setAsCurrentTab();
  }

  protected mdrtDashboardDisclaimer: string = "";

  protected isCurrentTabActive: boolean = false;
  protected targetYear: string = "";

  constructor() { }

  async ngOnInit(): Promise<void> {

    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.currentUserGroup = this.sessionStorageService.getCurrentUserGroup();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.mdrtStatusIncomeTableDisplayFirstColumn = ["repCode", "personName", "branch", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusCommissionTableDisplayFirstColumn = ["repCode", "personName", "branch", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusPremiumTableDisplayFirstColumn = ["repCode", "personName", "branch", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
    }
    else {
      this.mdrtStatusIncomeTableDisplayFirstColumn = ["repCode", "personName", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusCommissionTableDisplayFirstColumn = ["repCode", "personName", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusPremiumTableDisplayFirstColumn = ["repCode", "personName", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
    }
  }


  ngAfterViewInit(): void {
    this.mdrtStatusIncomeTableDataSource.paginator = this.mdrtStatusIncomeTablePaginator;
    this.mdrtStatusIncomeTableDataSource.sort = this.mdrtStatusIncomeTableSort;

    this.mdrtStatusCommissionTableDataSource.paginator = this.mdrtStatusCommissionTablePaginator;
    this.mdrtStatusCommissionTableDataSource.sort = this.mdrtStatusCommissionTableSort;

    this.mdrtStatusPremiumTableDataSource.paginator = this.mdrtStatusPremiumTablePaginator;
    this.mdrtStatusPremiumTableDataSource.sort = this.mdrtStatusPremiumTableSort;
  }

  async setAsCurrentTab(): Promise<void> {
    this.mdrtStatusIncomeData = [];
    this.mdrtStatusCommissionData = [];
    this.mdrtStatusPremiumData = [];

    this.mdrtStatusIncomeCount.mdrt = 0;
    this.mdrtStatusIncomeCount.cot = 0;
    this.mdrtStatusIncomeCount.tot = 0;

    this.mdrtStatusCommissionCount.mdrt = 0;
    this.mdrtStatusCommissionCount.cot = 0;
    this.mdrtStatusCommissionCount.tot = 0;

    this.mdrtStatusPremiumCount.mdrt = 0;
    this.mdrtStatusPremiumCount.cot = 0;
    this.mdrtStatusPremiumCount.tot = 0;

    if (this.isCurrentTabActive) {
      await this.getMdrtStatus();

      // this.mdrtStatusIncomeTableDataSource.data = this.mdrtStatusIncomeData;
      this.__applyIncomeMethodDataFilter();
      // this.mdrtStatusCommissionTableDataSource.data = this.mdrtStatusCommissionData;
      this.__applyCommissionMethodDataFilter();
      // this.mdrtStatusPremiumTableDataSource.data = this.mdrtStatusPremiumData;
      this.__applyPremiumMethodDataFilter();

      if (['Advisor'].includes(this.currentUserRole)) {
        this.isMdrtStatusDashboardHidden.set(true);
        this.isMdrtStatusFilterAndPaginatorHidden.set(true);
      }

      if (['Affinity'].includes(this.currentUserGroup)) {
        this.isAffinityUser.set(true);
      }
    }
  }

  async getMdrtStatus() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardMdrtStatusService
      .getDashboardMdrtStatus(Number.parseInt(this.targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        this.mapMdrtStatusData(responseData.data.responsedata.corporateapedata, responseData.data.responsedata.projectconfiguration);
      }
      // else if (this.currentUserRole === 'BDM') {
      //   this.mapMdrtStatusData(responseData.data.responsedata.bdmapedata, responseData.data.responsedata.projectconfiguration);
      // }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.mapMdrtStatusData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }
      else {
        this.mapMdrtStatusData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }

      this.setDisclaimers(responseData.data.responsedata.disclamirdata);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackbarServices.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackbarServices.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  private setDisclaimers(disclaimer: any[]) {
    if (this.targetYear == new Date().getFullYear().toString()) {
      this.mdrtDashboardDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "mdrt_dashboard")[0].dmText.toString();
    }
    else {
      this.mdrtDashboardDisclaimer = "The Information is based on data as at 31/12/2025.";
    }
  }

  protected mapMdrtStatusData(mdrtStatusList: any[], projConfig: any[]) {
    const incomeMdrtTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Income_MDRT")[0].pjConfValue;
    const incomeCotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Income_COT")[0].pjConfValue;
    const incomeTotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Income_TOT")[0].pjConfValue;
    const commissionMdrtTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Commision_MDRT")[0].pjConfValue;
    const commissionCotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Commision_COT")[0].pjConfValue;
    const commissionTotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Commision_TOT")[0].pjConfValue;
    const premiumMdrtTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Prenium_MDRT")[0].pjConfValue;
    const premiumCotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Prenium_COT")[0].pjConfValue;
    const premiumTotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Prenium_TOT")[0].pjConfValue;

    mdrtStatusList.forEach((mdrtStatusItem: any) => {
      // Income Method
      let mdrtStatusIncome: MdrtStatusByAdvisorsV2 = {
        repCode: mdrtStatusItem.piasRepCode,
        personName: mdrtStatusItem.agentRealName,
        branch: mdrtStatusItem.branch,
        mdrtQualification: "MDRT",
        mdrtTarget: incomeMdrtTarget,
        mdrtAchievedGr: mdrtStatusItem.mdrtIncomeMethodAchivedGr.toString(),
        mdrtShortfall: "0",
        mdrtMetorNotMet: mdrtStatusItem.minimumcriteriaincomemethod,
        cotQualification: "COT",
        cotTarget: incomeCotTarget,
        cotAchievedGr: mdrtStatusItem.mdrtIncomeMethodAchivedGr.toString(),
        cotShortfall: "0",
        cotMetorNotMet: mdrtStatusItem.cotcriteriaincomemethod,
        totQualification: "TOT",
        totTarget: incomeTotTarget,
        totAchievedGr: mdrtStatusItem.mdrtIncomeMethodAchivedGr.toString(),
        totShortfall: "0",
        totMetorNotMet: mdrtStatusItem.totcriteriaincomemethod
      };

      let incomeMdrtShortfall: number = 0;
      let incomeCotShortfall: number = 0;
      let incomeTotShortfall: number = 0;

      if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr)) {
        if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr) < Number.parseInt(incomeMdrtTarget)) {
          incomeMdrtShortfall = Number.parseInt(incomeMdrtTarget) - Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr);
        } else {
          incomeMdrtShortfall = 0;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr) < Number.parseInt(incomeCotTarget)) {
          incomeCotShortfall = Number.parseInt(incomeCotTarget) - Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr);
        } else {
          incomeCotShortfall = 0;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr) < Number.parseInt(incomeTotTarget)) {
          incomeTotShortfall = Number.parseInt(incomeTotTarget) - Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr);
        } else {
          incomeTotShortfall = 0;
        }
      } else {
        incomeMdrtShortfall = Number.parseInt(incomeMdrtTarget);
        incomeCotShortfall = Number.parseInt(incomeCotTarget);
        incomeTotShortfall = Number.parseInt(incomeTotTarget);
      }

      if (mdrtStatusItem.minimumcriteriaincomemethod) {
        this.mdrtStatusIncomeCount.mdrt = this.mdrtStatusIncomeCount.mdrt + 1;
      }

      if (mdrtStatusItem.cotcriteriaincomemethod) {
        this.mdrtStatusIncomeCount.cot = this.mdrtStatusIncomeCount.cot + 1;
      }

      if (mdrtStatusItem.totcriteriaincomemethod) {
        this.mdrtStatusIncomeCount.tot = this.mdrtStatusIncomeCount.tot + 1;
      }

      mdrtStatusIncome.mdrtShortfall = incomeMdrtShortfall.toString();
      mdrtStatusIncome.cotShortfall = incomeCotShortfall.toString();
      mdrtStatusIncome.totShortfall = incomeTotShortfall.toString();
      this.mdrtStatusIncomeData.push(mdrtStatusIncome);

      // Commission Method
      let mdrtStatusCommission: MdrtStatusByAdvisorsV2 = {
        repCode: mdrtStatusItem.piasRepCode,
        personName: mdrtStatusItem.agentRealName,
        branch: mdrtStatusItem.branch,
        mdrtQualification: "MDRT",
        mdrtTarget: commissionMdrtTarget,
        mdrtAchievedGr: mdrtStatusItem.mdrtCommisionMethodAchivedGr.toString(),
        mdrtShortfall: "0",
        mdrtMetorNotMet: mdrtStatusItem.minimumcriteriacommissionmethod,
        cotQualification: "COT",
        cotTarget: commissionCotTarget,
        cotAchievedGr: mdrtStatusItem.mdrtCommisionMethodAchivedGr.toString(),
        cotShortfall: "0",
        cotMetorNotMet: mdrtStatusItem.cotcriteriacommissionmethod,
        totQualification: "TOT",
        totTarget: commissionTotTarget,
        totAchievedGr: mdrtStatusItem.mdrtCommisionMethodAchivedGr.toString(),
        totShortfall: "0",
        totMetorNotMet: mdrtStatusItem.totcriteriacommissionmethod
      };

      let commissionMdrtShortfall: number = 0;
      let commissionCotShortfall: number = 0;
      let commissionTotShortfall: number = 0;

      if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr)) {
        if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr) < Number.parseInt(commissionMdrtTarget)) {
          commissionMdrtShortfall = Number.parseInt(commissionMdrtTarget) - Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr);
        } else {
          commissionMdrtShortfall = 0;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr) < Number.parseInt(commissionCotTarget)) {
          commissionCotShortfall = Number.parseInt(commissionCotTarget) - Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr);
        } else {
          commissionCotShortfall = 0;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr) < Number.parseInt(commissionTotTarget)) {
          commissionTotShortfall = Number.parseInt(commissionTotTarget) - Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr);
        } else {
          commissionTotShortfall = 0;
        }
      } else {
        commissionMdrtShortfall = Number.parseInt(commissionMdrtTarget);
        commissionCotShortfall = Number.parseInt(commissionCotTarget);
        commissionTotShortfall = Number.parseInt(commissionTotTarget);
      }

      if (mdrtStatusItem.minimumcriteriacommissionmethod) {
        this.mdrtStatusCommissionCount.mdrt = this.mdrtStatusCommissionCount.mdrt + 1;
      }

      if (mdrtStatusItem.cotcriteriacommissionmethod) {
        this.mdrtStatusCommissionCount.cot = this.mdrtStatusCommissionCount.cot + 1;
      }

      if (mdrtStatusItem.totcriteriacommissionmethod) {
        this.mdrtStatusCommissionCount.tot = this.mdrtStatusCommissionCount.tot + 1;
      }

      mdrtStatusCommission.mdrtShortfall = commissionMdrtShortfall.toString();
      mdrtStatusCommission.cotShortfall = commissionCotShortfall.toString();
      mdrtStatusCommission.totShortfall = commissionTotShortfall.toString();
      this.mdrtStatusCommissionData.push(mdrtStatusCommission);

      // Premium Method
      let mdrtStatusPremium: MdrtStatusByAdvisorsV2 = {
        repCode: mdrtStatusItem.piasRepCode,
        personName: mdrtStatusItem.agentRealName,
        branch: mdrtStatusItem.branch,
        mdrtQualification: "MDRT",
        mdrtTarget: premiumMdrtTarget,
        mdrtAchievedGr: mdrtStatusItem.mdrtPermiumMethodAchivedGr,
        mdrtShortfall: "0",
        mdrtMetorNotMet: mdrtStatusItem.minimumcriteriapremiummethod,
        cotQualification: "COT",
        cotTarget: premiumCotTarget,
        cotAchievedGr: mdrtStatusItem.mdrtPermiumMethodAchivedGr,
        cotShortfall: "0",
        cotMetorNotMet: mdrtStatusItem.cotcriteriapremiummethod,
        totQualification: "TOT",
        totTarget: premiumTotTarget,
        totAchievedGr: mdrtStatusItem.mdrtPermiumMethodAchivedGr,
        totShortfall: "0",
        totMetorNotMet: mdrtStatusItem.totcriteriapremiummethod
      };

      let premiumMdrtShortfall: number = 0;
      let premiumCotShortfall: number = 0;
      let premiumTotShortfall: number = 0;

      if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr)) {
        if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr) < Number.parseInt(premiumMdrtTarget)) {
          premiumMdrtShortfall = Number.parseInt(premiumMdrtTarget) - Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr);
        } else {
          premiumMdrtShortfall = 0;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr) < Number.parseInt(premiumCotTarget)) {
          premiumCotShortfall = Number.parseInt(premiumCotTarget) - Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr);
        } else {
          premiumCotShortfall = 0;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr) < Number.parseInt(premiumTotTarget)) {
          premiumTotShortfall = Number.parseInt(premiumTotTarget) - Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr);
        } else {
          premiumTotShortfall = 0;
        }
      } else {
        premiumMdrtShortfall = Number.parseInt(premiumMdrtTarget);
        premiumCotShortfall = Number.parseInt(premiumCotTarget);
        premiumTotShortfall = Number.parseInt(premiumTotTarget);
      }

      if (mdrtStatusItem.minimumcriteriapremiummethod) {
        this.mdrtStatusPremiumCount.mdrt = this.mdrtStatusPremiumCount.mdrt + 1;
      }

      if (mdrtStatusItem.cotcriteriapremiummethod) {
        this.mdrtStatusPremiumCount.cot = this.mdrtStatusPremiumCount.cot + 1;
      }

      if (mdrtStatusItem.totcriteriapremiummethod) {
        this.mdrtStatusPremiumCount.tot = this.mdrtStatusPremiumCount.tot + 1;
      }

      mdrtStatusPremium.mdrtShortfall = premiumMdrtShortfall.toString();
      mdrtStatusPremium.cotShortfall = premiumCotShortfall.toString();
      mdrtStatusPremium.totShortfall = premiumTotShortfall.toString();
      this.mdrtStatusPremiumData.push(mdrtStatusPremium);
    });

    this.mdrtStatusIncomeData.sort((item1, item2) => Number.parseInt(item2.mdrtAchievedGr) - Number.parseInt(item1.mdrtAchievedGr));
    this.mdrtStatusCommissionData.sort((item1, item2) => Number.parseInt(item2.mdrtAchievedGr) - Number.parseInt(item1.mdrtAchievedGr));
    this.mdrtStatusPremiumData.sort((item1, item2) => Number.parseInt(item2.mdrtAchievedGr) - Number.parseInt(item1.mdrtAchievedGr));

  }

  protected __applyIncomeMethodDataFilter() {
    let filterValue: string = this.mdrtStatusIncomeTableFilterFc.value?.toString() || '';

    let tempMrdtStatusIncomeMethodByAdvisorTableData: MdrtStatusByAdvisorsV2[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempMrdtStatusIncomeMethodByAdvisorTableData = this.mdrtStatusIncomeData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempMrdtStatusIncomeMethodByAdvisorTableData = this.mdrtStatusIncomeData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempMrdtStatusIncomeMethodByAdvisorTableData = this.mdrtStatusIncomeData;
    }

    this.mdrtStatusIncomeTableDataSource.data = tempMrdtStatusIncomeMethodByAdvisorTableData;
  }

  protected __applyCommissionMethodDataFilter() {
    let filterValue: string = this.mdrtStatusCommissionTableFilterFc.value?.toString() || '';

    let tempMrdtStatusCommissionMethodByAdvisorTableData: MdrtStatusByAdvisorsV2[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempMrdtStatusCommissionMethodByAdvisorTableData = this.mdrtStatusCommissionData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempMrdtStatusCommissionMethodByAdvisorTableData = this.mdrtStatusCommissionData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempMrdtStatusCommissionMethodByAdvisorTableData = this.mdrtStatusCommissionData;
    }

    this.mdrtStatusCommissionTableDataSource.data = tempMrdtStatusCommissionMethodByAdvisorTableData;
  }

  protected __applyPremiumMethodDataFilter() {
    let filterValue: string = this.mdrtStatusPremiumTableFilterFc.value?.toString() || '';

    let tempMrdtStatusPremiumMethodByAdvisorTableData: MdrtStatusByAdvisorsV2[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempMrdtStatusPremiumMethodByAdvisorTableData = this.mdrtStatusPremiumData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempMrdtStatusPremiumMethodByAdvisorTableData = this.mdrtStatusPremiumData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempMrdtStatusPremiumMethodByAdvisorTableData = this.mdrtStatusPremiumData;
    }

    this.mdrtStatusPremiumTableDataSource.data = tempMrdtStatusPremiumMethodByAdvisorTableData;
  }
  clearSearch(): void {
    this.mdrtStatusIncomeTableFilterFc.setValue('');
    this.__applyIncomeMethodDataFilter();
    this.searchInput.nativeElement.focus();
  }
  clearCommissionSearch(): void {
    this.mdrtStatusCommissionTableFilterFc.setValue('');
    this.__applyCommissionMethodDataFilter();
    this.commissionSearchInput.nativeElement.focus();
  }
  clearPremiumSearch(): void {
    this.mdrtStatusPremiumTableFilterFc.setValue('');
    this.__applyPremiumMethodDataFilter();
    this.premiumSearchInput.nativeElement.focus();
  }




}
